(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Prism", [], factory);
	else if(typeof exports === 'object')
		exports["Prism"] = factory();
	else
		root["Prism"] = factory();
})(this, () => {
return 